// eslint-disable-next-line import/prefer-default-export
export const ELEMENT_FRAME_COLOR = '#0075FF';
export const ELEMENT_FRAME_SCALE_FACTOR = 2;
export const ELEMENT_CONTROL_FILL_COLOR = '#fff';
